import React from 'react';
import { SectionLayout } from '@/components/shared/section-layout';

export function ProposalTemplatesPage() {
  return (
    <SectionLayout title="Proposal Templates" />
  );
} 